/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGhost = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M12 12c.552 0 1 .672 1 1.5s-.448 1.5-1 1.5-1-.672-1-1.5.448-1.5 1-1.5zm-1-1H9V9h2zm4 0h-2V9h2z" />
        <path d="M12 2c4.384 0 8 3.436 8 7.75V22h-3.737l-.29-.28-1.64-1.581L12 22.389l-2.334-2.25L7.737 22H4V9.75C4 5.436 7.616 2 12 2zm0 2C8.652 4 6 6.608 6 9.75V20h.93l2.737-2.64.693.67L12 19.61l1.64-1.58.693-.67L17.069 20H18V9.75C18 6.608 15.348 4 12 4z" />
      </g>
    </g>
  </Icon>
);
export { SvgGhost as Ghost };
